import React, { FC, ReactNode } from 'react'

// style components
import { Container, InputWrapper } from './Input.style'

interface Props {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    value?: string
    placeholder?: string
    type?: string
    leftIcon?: ReactNode
    rightIcon?: ReactNode
}

const Input: FC<Props> = ({ onChange, value = '', placeholder, type = 'text', leftIcon, rightIcon }) => {
    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e)
    }

    return (
        <Container>
            {leftIcon}
            <InputWrapper
                data-testid="general-input"
                type={type}
                value={value}
                onChange={onInputChange}
                placeholder={placeholder}
            />
            {rightIcon}
        </Container>
    )
}

export default Input
